import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { RequestConfirmationV2Component } from "../request-confirmation-v2/request-confirmation-v2.component";
import { AppLocalStorage } from "../../../../../@core/utils/local-storage.util";
import { environment } from "../../../../../../environments/environment";

@Component({
  selector: 'ltts-approval-details-v2',
  templateUrl: './approval-details-v2.component.html',
  styleUrls: ['./approval-details-v2.component.scss']
})
export class ApprovalDetailsV2Component implements OnInit {
 @Output() backEvent = new EventEmitter<boolean>();
  @Output() approveEvent = new EventEmitter<any>(); // Emit an object
  @Output() declineEvent = new EventEmitter<any>();

  approvedRequests: Set<any> = new Set();
  declinedRequests: Set<any> = new Set();
  private cmsbase_url: string;
  EmptyState: string;


  constructor(private dialogService: NbDialogService, private cdr: ChangeDetectorRef,) {

  }

  // isApproved: boolean = false; // Track approval status
  appUrl: any;
  showRemarkError: boolean = false;

  parentData: any;
  profileData;
  @Input() public set reqData(val) {
    this.parentData = val;
 this.appUrl=this.parentData?.appUrl
    this.headerTitle =
      `${this.parentData?.appName}` +
      " (" +
      `${this.parentData?.totalRequests}` + ")";
  }
  headerTitle: string = "";

  ngOnInit(): void {
    const me = this;
    this.cmsbase_url = environment.CMSURL_IMG;
    this.EmptyState = this.cmsbase_url+"wp-content/uploads/2025/05/EmptyState.png";
  }

  goBack() {
    const me = this;
    me.backEvent.emit(true);
  }

  approveRequest(index,item, request, parentData?: any) {
    const profile = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")
  let approvalData = {}
    switch(item.categoryName) {
      case 'Attendance': {
        approvalData = {
          "category": item.categoryName,
          "userId": 0,
          "employeeId": item.employeeId,
          "fromDate": request.date,
          "toDate" : request.date,
          "ticketID": ""
          };
         break;
      }
      case 'Leave': {
         approvalData = {
          "category": item.categoryName,
          "userId": profile.profile.employeeId,
          "employeeId": parentData.employeeId,
          "fromDate": request.leaveFrom,
          "toDate" : request.leaveTo,
          "ticketID": request.wfRequestId
          }
         break;
      }
      case 'Accommodation': {
        approvalData = {
          "category": item.categoryName,
          "userId": 0,
          "employeeId": request.requestorPsNo,
          "fromDate": request.fromDate,
          "toDate" : request.toDate,
          "ticketID": request.requestID
          }
        break;
     }
     case 'Car': {
      approvalData = {
        "category": item.categoryName,
        "userId": 0,
        "employeeId": request.travellerPsNo,
        "fromDate": request.pickupDate,
        "toDate" : request.pickupDate,
        "ticketID": request.requestID,
        }
      break;
   }
   case 'Synergy':{
    approvalData = {
      category: item.advanceFlag ? 'synergyrequest' : 'synergysettlement',
      remark: item.remark ?? '',
      userId: profile.profile.employeeId,
      employeeId: 0,
      ticketID: item.voucherId,
    }
    break;
   }
      default: {
         //statements;
         break;
      }
   }

    // const approvalData = {
    // "category": item.categoryName,
    // "userId": 0,
    // "employeeId": item.employeeId,
    // "fromDate": request.date,
    // "toDate" : request.date,
    // "ticketID": ""
    // };

    // const approvalData = {
    //   empid: item.employeeId,
    //   categoryName: item.categoryName,
    //   requestDate: request.date,
    // };

    // this.approveEvent.emit(approvalData);
    // request['isApproved'] = true;

    this.dialogService.open(RequestConfirmationV2Component, {
      context: {
        title: 'Are you sure you want to approve the request?',
        reqData : approvalData,
        action: 'approve'
      },
    }).onClose.subscribe((value) => {
      if (value) {
        request['isApproved'] = true;
        this.approveEvent.emit(this.parentData?.appName);
        this.cdr.detectChanges();
      }
    });

    // this.approvedRequests.add(this.getRequestKey(item, request));


  }
  open() {
    this.dialogService.open(RequestConfirmationV2Component)
      .onClose.subscribe();
  }
  declineRequest(index,item, request, parentData?: any) {
    const profile = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")
    // const declineData = {
    //   empid: item.employeeId,
    //   categoryName: item.categoryName,
    //   requestDate: request.date,
    //   remark: request.remark,
    // };
    request.showRemarkError = false;

    if(!request.remark){
      request.showRemarkError = true;
      return
    }

    if(request.remark){


      if(request.remark.trim() == ''  ){
        request.showRemarkError = true;
return;
      }
    }

    let declineData = {}
    switch(item.categoryName) {
      case 'Attendance': {
        declineData = {
          "category": item.categoryName,
          "userId": 0,
          "employeeId": item.employeeId,
          "fromDate": request.date,
          "toDate" : request.date,
          "ticketID": "",
          remark: request.remark ? request.remark : ''
          };
         break;
      }
      case 'Leave': {
        declineData = {
          "category": item.categoryName,
          "userId": profile.profile.employeeId,
          "employeeId": parentData.employeeId,
          "fromDate": request.leaveFrom,
          "toDate" : request.leaveTo,
          "ticketID": request.wfRequestId,
          remark: request.remark ? request.remark : ''
          }
         break;
      }
      case 'Accommodation': {
        declineData = {
          "category": item.categoryName,
          "userId": 0,
          "employeeId": request.requestorPsNo,
          "fromDate": request.fromDate,
          "toDate" : request.toDate,
          "ticketID": request.requestID,
          remark: request.remark ? request.remark : ''
          }
        break;
     }
     case 'Car': {
      declineData = {
        "category": item.categoryName,
        "userId": 0,
        "employeeId": request.travellerPsNo,
        "fromDate": request.pickupDate,
        "toDate" : request.pickupDate,
        "ticketID": request.requestID,
        remark: request.remark ? request.remark : ''
        }
      break;
   }
   case 'Synergy':{
    declineData = {
      category: item.advanceFlag ? 'synergyrequest' : 'synergysettlement',
      remark: item.remark ?? '',
      userId: profile.profile.employeeId,
      employeeId: 0,
      ticketID: item.voucherId,
    }
    break;
   }
      default: {
         //statements;
         break;
      }
   }

    // this.declineEvent.emit(declineData);
    // request['isDeclined'] = true;

    this.dialogService.open(RequestConfirmationV2Component, {
      context: {
        title: 'Are you sure you want to decline the request?',
        reqData : declineData,
        action: 'decline'
      },
    }).onClose.subscribe((value) => {
      if (value) {
        request['isDeclined'] = true;
        this.declineEvent.emit(this.parentData?.appName);
        // item.requests.splice(index, 1);
        this.cdr.detectChanges();
      }
    });


    // this.declinedRequests.add(this.getRequestKey(item, request));

  }

  // isApproved(item: any, request: any): boolean {
  //   return this.approvedRequests.has(this.getRequestKey(item, request));
  // }

  // isDeclined(item: any, request: any): boolean {
  //   return this.declinedRequests.has(this.getRequestKey(item, request));
  // }

  // private getRequestKey(item: any, request: any): string {
  //   return `${item.employeeId}-${request.date}`;
  // }

  view(url) {
    window.open(url, "_blank");
  }

  onApproveSuccess() {
    // this.isApproved = true; // Set to true when approved
  }
}
